webpackJsonp([84681108332385],{

/***/ 1361:
/***/ (function(module, exports) {

	module.exports = {"data":{"allBlogJson":{"edges":[{"node":{"title":"A Startup’s Experience Getting to MVP with Code Fellows Alums","metaDescription":"Looking for resources as you learn to code? The Code Fellows blog features helpful tutorials, alumni stories, student projects, school news, and more!","slug":"blog/a-startups-experience-getting-to-mvp-with-code-fellows-alums","createdAt":"2018-04-20T17:46:13.421Z","blogAuthor":{"fields":{"name":"James Ni","slug":"blog/author/james-ni"}},"imageHeader":{"fields":{"file":{"url":"//images.ctfassets.net/k428n7s2pxlu/52yUzqUII0Im2W6wyEEC6w/b18828659e051e5368584fc418e8bf68/blog-post-blog-a-startups-experience-getting-to-mvp-with-code-fellows-alums.png"}}}}}]},"authorJson":{"name":"James Ni","slug":"blog/author/james-ni","twitter":null,"linkedIn":null,"website":null,"biography":null,"image":null}},"pathContext":{"slug":"blog/author/james-ni"}}

/***/ })

});


// WEBPACK FOOTER //
// path---blog-author-james-ni-8989e09235e3b6c292f3.js